export * from "@emotion/weak-memoize";
export { default } from "@emotion/weak-memoize";
